const getters = {
    salesorders: (state) => state.salesorders,
    salesorderId: (state) =>state.salesorderId,
    NewSalesOrder: (state) => state.NewSalesOrder,
    inventoryStatus: (state) => state.inventoryStatus,
    loading: state => state.loading,
    documents: (state) => state.documents,
    file: state => state.file,
    docLoader: state => state.docLoader,
};

export default getters;